import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import _ from 'underscore';
import auth0 from '../../helpers/auth0';

const $ = window.$;

var AutocompleteText = createReactClass({
  propTypes: {
    name: PropTypes.string,
    idProp: PropTypes.string.isRequired,
    displayProp: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    dataUrl: PropTypes.string.isRequired,
    searchPlaceholder: PropTypes.string,
    inputTooShortText: PropTypes.string,
    noMatchesText: PropTypes.string,
    searchInProgressText: PropTypes.string,
    staticQueryParams: PropTypes.object,
    allowNewEntries: PropTypes.bool.isRequired,
  },
  getDefaultProps() {
    return {
      staticQueryParams: {},
      allowNewEntries: false,
    };
  },
  getInitialState() {
    return {
      searchId: _.uniqueId('autocomplete-')
    };
  },
  resetSelection() {
    $('#' + this.state.searchId).select2('data', null);
  },
  setSelection(element) {

    $('#' + this.state.searchId).select2('data', element);

    this.props.onSelect(element);
  },
  formatResult(element) {
    var markup = '<div class="row">' +
            '<div class="col-md-12">' + element[this.props.displayProp] + '<div>' +
            '</div>';

    return markup;
  },
  formatSelection(element) {
    return element[this.props.displayProp];
  },
  componentDidMount() {
    let props = this.props;

    let select2Props = {
      placeholder: props.searchPlaceholder,
      searchInputPlaceholder: props.searchPlaceholder,
      minimumInputLength: 0,
      ajax: {
        url: props.dataUrl,
        dataType: 'json',
        quietMillis: 250,
        params: {
          headers: {
            'Authorization' : 'Bearer ' + auth0.getAccessToken()
          }
        },
        data(termParam, pageParam) {

          return {
            Term: termParam,
            Page: pageParam,
            PageSize: 30,
            ...props.staticQueryParams
          };
        },
        results(data, page) {

          if (data.hasResults === false) {
            return { results: [], more: false };
          }
          var more = (page * 30) < data.totalCount;

          return { results: data.elements, more: more };
        }
      },
      formatResult: this.formatResult,
      formatSelection: this.formatSelection,
      formatNoMatches: props.noMatchesText,
      formatSearching: props.searchInProgressText,
      formatInputTooShort: props.inputTooShortText,
      escapeMarkup(m) {
        return m;
      }
    };

    if (props.allowNewEntries) {
      _.extend(select2Props, {
        createSearchChoice: function(term) {
          let result = {
            id: _.uniqueId('new-entry-'),
            newEntry: true,
          };

          result[props.displayProp] = term;

          return result;
        }
      });
    }

    var selectCallback = props.onSelect;

    $('#' + this.state.searchId).select2(select2Props);

    $('#' + this.state.searchId).on('change', e => {
      if ( (e.added !== undefined) &&(e.added != null ) ) {
        selectCallback(e.added);
      }
    });

    $('#' + this.state.searchId).on('select2-close', e => {
      if (props.onBlur) {
        e.target.name = props.name;
        props.onBlur(e);
      }
    });
  },
  render() {
    var styles = { width: '100%' };

    return (
      <input id={this.state.searchId} className="select2" type="text" placeholder={this.props.searchPlaceholder} style={styles} />
    );
  }

});

export default AutocompleteText;



// WEBPACK FOOTER //
// ./src/components/common/AutocompleteText.js